var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3335 12.2502H11.6668M3.30533 7.69261C3.0566 7.94189 2.91689 8.27964 2.91683 8.63178V10.5002H4.79691C5.14925 10.5002 5.487 10.3602 5.73608 10.1105L11.2777 4.56595C11.5264 4.31663 11.666 3.97889 11.666 3.62678C11.666 3.27467 11.5264 2.93693 11.2777 2.68761L10.7306 2.13928C10.6072 2.01582 10.4607 1.91789 10.2994 1.85109C10.1381 1.7843 9.96526 1.74995 9.79071 1.75C9.61615 1.75005 9.44332 1.78451 9.28209 1.85141C9.12086 1.91831 8.9744 2.01632 8.85108 2.13986L3.30533 7.69261Z",
    stroke: "#A2A2A2",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/editPencil.736f88f0d9e24d6daa756db8453d18a0.svg";
export { ForwardRef as ReactComponent };